import React from "react";
import { useNavigate } from "react-router-dom";
import { Copy, Trash } from "lucide-react";
import Button from "../../../components/Button";

export function ViewWorkflowHeader({
  workflow,
  isLoading,
  onDelete,
  isScheduled,
  onAddNewContextObject,
}) {
  const navigate = useNavigate();

  return (
    <div className="flex sm:flex-row flex-col justify-between mb-8">
      <div className="sm:w-1/2 w-full">
        <h1 className="text-2xl font-bold mb-2">
          {isLoading ? "Loading..." : workflow?.name ? workflow.name : "..."}
        </h1>
        <h2 className="text-lg font-semibold text-gray-500">
          Tenant: {workflow?.tenant || "..."}
        </h2>
      </div>

      <div className="flex items-center sm:mt-0 mt-4 space-x-2">
        <button onClick={onDelete} className="bg-slate-100 rounded-md p-2 ml-3">
          <Trash size={17} />
        </button>

        <button
          onClick={() =>
            navigate(`/workflows/manage`, { state: { workflow } })
          }
          className="bg-slate-100 rounded-md p-2 ml-3"
        >
          <Copy size={17} />
        </button>

        {isScheduled && (
          <div className="mr-3">
            <Button label={"Add new variant"} onClick={onAddNewContextObject} />
          </div>
        )}

        <Button
          label={"Edit workflow"}
          onClick={() => navigate(`/workflows/${workflow.id}/manage`)}
        />
      </div>
    </div>
  );
}
